module.exports = __webpack_public_path__ + "static/media/cosmWasmLogo.d3695d54.svg";